/* eslint-disable */
import React, { PureComponent } from 'react'
import {
  Grid,
  Paper,
  Radio,
  FormControlLabel,
  RadioGroup,
  FormControl,
  FormLabel,
  Select,
  MenuItem,
  Button,
  ListItem,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Switch,
  FormGroup,
  Tabs,
  Tab,
} from '@material-ui/core'
import {
  getQuickBookConfigurations,
  downloadQuickBookFile,
  getQuickBookToken,
  saveEntities,
  saveAccountEntities,
  disconnectQuickbook,
  quickbookSyncEntities,
  getQuickBookOperations,
  getQuickBookAccountDetails,
  updateQuickBookOperations,
  getQuickBookLogs,
  reSyncQuickBookOperations,
  reset,
  getProductCataogies,
  getQuickbookEntity,
  urlConnectToQuickBooks,
  getQuickBookRefreshToken,
  getQuickBookRevokeToken,
  quickBookOnlineDataSync,
  getQuickBookSyncJobs,
  getQuickBookOnlineTokenInfo,
} from '../../../actions/thirdParty'
import { connect } from 'react-redux'
import ContainerWithTitleWrapper from '../../HOC/ContainerWithTitle'
import { openErrorMessage, openSuccessMessage } from '../../../actions/message'
import { C2QB } from '../../../assets'
import { getObject, hasAccess } from '../../../utils/api'
import { EditableTextField } from '../../../components/common/EditableComponents'
import QuickBookConfig from '../../../components/QuickBook/QuickBookConfig'
import QuickBookLogs from '../../../components/QuickBook/QuickBookLogs'
import ModalDialog from '../../../components/common/ModalDialog'
import { isValidString } from '../../../utils/string'
//import QuickBookCategories from "../../../components/QuickBook/QuickBookCategories";
//import QuickBookProduct from "../../../components/QuickBook/QuickBookProduct";
import QuickBookCOAMapping from '../../../components/QuickBook/QuickBookCOAMapping'
import { getCompanyFeatures } from '../../../actions/company'
import { getShopList } from '../../../actions/shop'
import { getTaxesDisplayNames } from '../../../actions/shop'
import QuickBookSyncJobs from '../../../components/QuickBook/QuickBookSyncJobs'
import { TableCellWithText } from '../../../components/common/PureItems'
import moment from 'moment'
import Checkbox from '@material-ui/core/Checkbox'

const onQuickBookTabs = ['Config', 'Sync Details', 'COA Mapping', 'Sync Jobs']
const onQuickBookAccountTabs = ['Default', 'Category Wise', 'Product Wise']

class QuickBook extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      quickbook: {},
      quickbookOpt: {},
      isSaved: false,
      isAccCheck: false,
      activeTab: 'Config',
      activeAccountTab: 'Default',
      quickBookDesktopAccountsMap: {},
      isRouteActive: Boolean,
      quickbookmethology: '',
      logs: [],
      categories: [],
      qbCustomAccount: '',
      taxDisplayNames: [],
      quickBookEntity: {},
    }
    this.getQuickBookOperations = this.getQuickBookOperations.bind(this)
    this.getShopList = this.getShopList.bind(this)
  }

  componentWillReceiveProps(nextProps, nextContext) {}

  getCompanyFeatures() {
    this.props.dispatch(getCompanyFeatures()).then((res) => {
      const session = JSON.parse(window.localStorage.getItem('session'))
      const isActive = !!(
        res &&
        res.availableQbShops &&
        res.availableQbShops[session.assignedShop.id]
      )
      this.setState({
        isRouteActive: isActive,
      })
    })
  }

  componentDidMount() {
    this.getCompanyFeatures()

    this.getQuickBookConfigurations()

    this.getQuickBookOperations()
    this.getQuickBookSyncLogs(0, 10)
    this.getQuickBookSyncJobs(0, 10)
    this.getCategories()
    this.getQuickbookEntity()
    this.getShopList()
    this.getTaxesDisplayNames()
  }

  getShopList = () => {
    this.props.dispatch(getShopList())
  }

  getTaxesDisplayNames = () => {
    this.props.dispatch(getTaxesDisplayNames()).then((res) => {
      this.setState({ taxDisplayNames: res })
    })
  }
  getQuickbookEntity = () => {
    this.props.dispatch(getQuickbookEntity()).then((res) => {
      this.setState({
        quickBookEntity: res,
      })
    })
  }

  getCategories = () => {
    this.props.dispatch(getProductCataogies()).then((res) => {
      this.setState({
        categories: res && res.values,
      })
    })
  }

  getQuickBookOperations = () => {
    this.props.dispatch(getQuickBookOperations()).then((res) => {
      const qbDesktopOperations = res.qbDesktopOperations
      const quickBookDesktopAccountsMap = res.quickBookDesktopAccountsMap
      this.setState({
        quickbookOpt: {
          qbDesktopOperations,
          quickBookDesktopAccountsMap,
        },
      })
    })
  }

  getQuickBookConfigurations = () => {
    this.props
      .dispatch(getQuickBookConfigurations())
      .then((res) => {
        this.setState(
          {
            quickbook: res,
          },
          () => {
            let referenceId = this.state.quickbook.entitiesId
            this.getQuickBooAccountDetails(referenceId)
          },
        )
        if (this.state.quickbook.qbCustomAccount !== 'None') {
          this.setState({
            isAccCheck: this.state.quickbook.qbCustomAccount !== 'QbSync',
          })
        } else {
          this.setState({
            isAccCheck: false,
          })
        }

        this.setState({
          isSaved: this.state.quickbook.qbCustomAccount === 'None',
          qbCustomAccount: this.state.quickbook.qbCustomAccount,
        })
      })
      .then((res) => {
        this.getQuickBookOnlineTokenInfo()
      })

    this.getQuickbookEntity()
  }
  getQuickBooAccountDetails = (referenceId) => {
    this.props.dispatch(getQuickBookAccountDetails(referenceId)).then((res) => {
      if (!!res) {
        this.setState({
          quickbook: { ...this.state.quickbook, ...res, isQuickBookDetail: true },
        })
      }
    })
  }

  getQuickBookSyncLogs = (start, limit) => {
    const data = {
      start: start,
      limit: limit,
    }
    this.props.dispatch(getQuickBookLogs(data)).then((res) => {
      this.setState({
        logs: res,
      })
    })
  }

  getQuickBookSyncJobs = (start, limit) => {
    const data = {
      start: start,
      limit: limit,
    }
    this.props.dispatch(getQuickBookSyncJobs(data)).then((res) => {
      this.setState({
        jobs: res,
      })
    })
  }

  getQuickBookOnlineTokenInfo = () => {
    const { quickbook } = this.state
    if (quickbook.qbtypes && quickbook.qbtypes == 'quickbook_online') {
      this.props.dispatch(getQuickBookOnlineTokenInfo()).then((res) => {
        console.log('QB', res)
        this.setState({
          tokenInfo: res,
        })
      })
    }
  }

  handleChange = (key, isCheckBox) => (event) => {
    const value = isCheckBox ? event.target.checked : event.target.value
    // this.state.isAccCheck = isCheckBox ? event.target.checked : false;
    this.setState((prevState) => {
      return {
        quickbook: {
          ...prevState.quickbook,
          [key]: value,
        },
      }
    })
  }

  onChange = (key, AccountsType) => (selections) => {
    if (selections) {
      const value = selections.value
      this.setState((prevState) => {
        return {
          quickbook: {
            ...prevState.quickbook,
            [key]: value,
          },
        }
      })
      var data = {
        accountName: selections.value,
      }
      if (
        this.state.quickbookOpt.quickBookDesktopAccountsMap[AccountsType].filter(
          (res) => res.accountName === data.accountName,
        ).length <= 0
      ) {
        this.state.quickbookOpt.quickBookDesktopAccountsMap[AccountsType].push(data)
      }
    }
  }
  saveSyncStrategies = () => {
    const { quickbook = {} } = this.state

    let {
      quickbookmethology,
      qbtypes = '',
      syncStrategy = '',
      inventory = '',
      sales = '',
      suppliesAndMaterials = '',
      payableAccount = '',
      checking = '',
      clearance = '',
      cc_clearance = '',
      income = '',
      syncAllProducts = false,
      qbCustomAccount,
    } = quickbook

    this.setState({ disabled: false })
    quickbookmethology = quickbookmethology == null ? 'sync individual' : quickbookmethology
    qbtypes = qbtypes == null ? 'quickbook_desktop' : qbtypes
    syncStrategy = syncStrategy == null ? 'all data' : syncStrategy
    qbCustomAccount = this.state.isAccCheck ? 'Custom' : 'QbSync'
    var QBData = {
      qbtypes,
      syncStrategy,
      quickbookmethology,
      inventory,
      sales,
      suppliesAndMaterials,
      payableAccount,
      checking,
      cc_clearance,
      income,
      qbCustomAccount,
      clearance,
      syncAllProducts,
    }

    this.props
      .dispatch(saveEntities(QBData))
      .then((response) => {
        this.getQuickBookOperations()
        this.getQuickBookConfigurations()
        this.setState({
          isSaved: true,
        })
        this.confirmModal.handleClose()
        this.props.dispatch(openSuccessMessage('Changes have been saved successfully'))
      })
      .catch(function (error) {
        console.log(error)
      })
  }
  saveCustomEntities = () => {
    const {
      entitiesId,
      inventory,
      sales,
      suppliesAndMaterials,
      payableAccount,
      checking,
      cc_clearance,
      clearance,
      receivable,
      cityTaxAcc = '',
      stateTaxAcc = '',
      countyTaxAcc = '',
      federalTaxAcc = '',
      cultivationTaxAcc = '',
      feesAcc = '',
    } = this.state.quickbook
    const QBData = {
      referenceId: entitiesId,
      accountType: 'Default',
      inventory: inventory,
      sales: sales,
      suppliesAndMaterials: suppliesAndMaterials,
      payableAccount: payableAccount,
      checking: checking,
      clearance: clearance,
      cc_clearance: cc_clearance,
      receivable: receivable,
      cityTaxAcc: cityTaxAcc,
      stateTaxAcc: stateTaxAcc,
      countyTaxAcc: countyTaxAcc,
      federalTaxAcc: federalTaxAcc,
      cultivationTaxAcc: cultivationTaxAcc,
      feesAcc: feesAcc,
      status: true,
    }
    this.props.dispatch(saveAccountEntities(QBData)).then((response) => {
      this.confirmModal.handleClose()
      if (response != null) {
        this.props.dispatch(openSuccessMessage('Changes have been saved successfully'))
        this.getQuickBookOperations()
        this.getQuickBookConfigurations()
        this.setState({ alertdisplay: response })
        this.timer = setTimeout((param) => {
          this.setState({ alertdisplay: null })
        }, 3000)
      }
    })
  }

  hasAccessQuickBook = () => {
    let session = getObject('session')
    if (session == null) {
      return false
    }
    return !!(
      (session.employee && session.employee.role && session.employee.role.name === 'Admin') ||
      (session.employee &&
        session.employee.role &&
        session.employee.role.permissions.find((perm) => perm === 'WebQuickBookManage'))
    )
  }

  updateQuickBookOperations = (data) => {
    if (data) {
      this.props.dispatch(updateQuickBookOperations(data)).then((response) => {
        this.props.dispatch(openSuccessMessage('Changes have been saved successfully'))
      })
    }
  }
  reSync = (data) => {
    // reSyncQuickBookOperations
    if (data) {
      this.props.dispatch(reSyncQuickBookOperations(data)).then((response) => {
        this.props.dispatch(
          openSuccessMessage(
            'Re synchronization has been enabled, in next QuickBooks sync, ' +
              "blaze will try to re sync it's data",
          ),
        )
      })
    }
  }

  renderTab = (activeTab) => {
    const { quickbook } = this.state
    let allAccountsList
    if (!!quickbook.qbtypes && quickbook.qbtypes == 'quickbook_online') {
      allAccountsList = quickbook.qbOnlineAccountInfo || []
    } else {
      allAccountsList = quickbook.qbDesktopAccounts || []
    }
    switch (activeTab) {
      case 'Config':
        return (
          <QuickBookConfig
            key={'1'}
            updateQuickBookOperations={this.updateQuickBookOperations.bind(this)}
            reSync={this.reSync}
          />
        )
      case 'Sync Details':
        return (
          <QuickBookLogs logs={this.state.logs} getQuickBookSyncLogs={this.getQuickBookSyncLogs} />
        )
      case 'COA Mapping':
        return (
          <QuickBookCOAMapping
            getQuickBookAccounts={this.state.quickbookOpt.quickBookDesktopAccountsMap}
            categories={this.state.categories}
            quickbookmethology={this.state.quickbook.quickbookmethology}
            allAccountsList={allAccountsList}
            getCategories={this.getCategories}
          />
        )

      case 'Sync Jobs':
        return (
          <QuickBookSyncJobs
            jobs={this.state.jobs}
            getQuickBookSyncJobs={this.getQuickBookSyncJobs}
          />
        )
      default:
        return null
    }
  }

  handleTabChange = (event, tab) => {
    this.setState({
      activeTab: tab,
    })
  }

  qbTabs = (qbtypes) => {
    return onQuickBookTabs.map((tab, i) => {
      if ('quickbook_online' == qbtypes) {
        if (!(tab == 'Config')) {
          return <Tab key={i} label={tab} value={tab} />
        }
      } else if ('quickbook_desktop' == qbtypes) {
        if (!(tab == 'Sync Jobs')) {
          return <Tab key={i} label={tab} value={tab} />
        }
      }
    })
  }

  getToken = () => {
    this.props
      .dispatch(getQuickBookToken())
      .then(function (response) {
        window.open(response, '_blank')
      })
      .catch(function (error) {
        console.log(error)
      })
  }

  getQwcFile = () => {
    let data = {
      qwcPassword: this.state.quickBookEntity.qbPassword,
    }
    this.props
      .dispatch(downloadQuickBookFile(data))
      .then((response) => {
        window.open(response, '_self')
        this.setState({
          qbCustomAccount: 'QbSync',
        })
      })
      .catch(function (error) {
        console.log(error)
      })
  }

  downloadFile = () => {
    if (!isValidString(this.state.quickbook.qwc_password)) {
      this.props.dispatch(openErrorMessage('Password must be provided'))
      return
    }

    let data = {
      qwcPassword: this.state.quickbook.qwc_password,
    }
    this.props
      .dispatch(downloadQuickBookFile(data))
      .then((response) => {
        window.open(response, '_self')
        this.passwordModal.handleClose()
        this.setState({
          qbCustomAccount: 'QbSync',
        })
        this.getQuickbookEntity()
      })
      .catch(function (error) {
        this.passwordModal.handleClose()
        console.log(error)
      })
  }
  Reset = () => {
    this.props
      .dispatch(reset())
      .then((response) => {
        window.open(response, '_self')
        this.resetModal.handleClose()
        this.getQuickBookOperations()
        this.getQuickBookConfigurations()
        this.setState({
          logs: [],
        })
      })
      .catch(function (error) {
        this.resetModal.handleClose()
        console.log(error)
      })
  }

  openPasswordModal = () => {
    this.passwordModal.handleClickOpen()
  }
  openResetModal = () => {
    this.resetModal.handleClickOpen()
  }

  disconnect = () => {
    const { quickbook = {} } = this.state

    let { qbtypes = '' } = quickbook

    var QBData = {
      qbtypes,
    }
    this.props
      .dispatch(disconnectQuickbook(QBData))
      .then((response) => {
        //console.log(response);
        this.getQuickBookOperations()
        this.getQuickBookConfigurations()
      })
      .catch(function (error) {
        console.log(error)
      })
  }

  openModal = () => {
    this.confirmModal.handleClickOpen()
  }

  launchPopupQuickBookOnline = () => {
    const parameters =
      'location=0,width=800,height=650,left=' +
      (screen.width - 800) / 2 +
      ',top=' +
      (screen.height - 650) / 2
    this.props
      .dispatch(urlConnectToQuickBooks())
      .then(function (responseUrl) {
        window.location = responseUrl
      })
      .catch(function (error) {
        console.log(error)
      })
  }

  getRefreshToken = () => {
    this.props.dispatch(getQuickBookRefreshToken()).then(() => {
      this.getQuickBookOnlineTokenInfo()
    })
  }
  revokeToken = () => {
    this.props
      .dispatch(getQuickBookRevokeToken())
      .then(function (response) {
        window.location.reload()
      })
      .catch(function (error) {
        console.log(error)
      })
  }
  dataSync = () => {
    this.props.dispatch(quickBookOnlineDataSync()).then(() => {
      this.getQuickBookSyncJobs(0, 10)
    })
  }

  render() {
    let activeTab = this.state.activeTab
    const { quickbook = {}, taxDisplayNames } = this.state
    const { activeAccountTab, quickBookEntity } = this.state
    const { qbDesktopOperations = [], quickBookDesktopAccountsMap = {} } = this.state.quickbookOpt
    const isActive = this.state.isRouteActive
    const {
      qbOnlineAccountInfo = [],
      qbDesktopAccounts = [],
      accounts = false,
      accountList = [],
      sales = '',
      qbCompanyId = '',
      qbtypes = '',
      quickbookmethology = '',
      syncAllProducts = false,
      syncStrategy = '',
      suppliesAndMaterials = '',
      feesAcc = '',
      inventory = '',
      cc_clearance = '',
      receivable = '',
      cityTaxAcc = '',
      stateTaxAcc = '',
      countyTaxAcc = '',
      federalTaxAcc = '',
      cultivationTaxAcc = '',
      clearance = '',
      payableAccount = '',
      income = '',
      checking = '',
      purchaseOrder = '',
      expenseSyncLastDate = '',
      expenseTotalSync = '',
      expenseTotalFail = '',
      salesbyconsumerLastDate = '',
      salesConsumerTotalSync = '',
      salesConsumerTotalFail = '',
      salesByProductLastDate = '',
      salesByproductTotalSync = '',
      salesbyproductTotalFail = '',
      refundLastSyncDate = '',
      refundTotalSync = '',
      refundTotalFail = '',
      saleslastSyncDate = '',
      salesTotalSync = '',
      salesTotalFail = '',
      billLastSyncDate = '',
      billTotalSync = '',
      billTotalFail = '',
      purchaseLastSyncDate = '',
      purchaseTotalSync = '',
      purchaseTotalFail = '',
      bill = false,
      salesReceipt = false,
      refundReceipt = false,
      inprogress = false,
      qwc_password = '',
      isQuickBookDetail = false,
    } = quickbook
    const { shopsList = {} } = this.props.shopReducer

    const getShop =
      shopsList &&
      shopsList.values &&
      shopsList.values.length &&
      shopsList.values.find((shop) => shop.id === quickBookEntity.shopId)
    const noAcconut =
      "We couldn't find account in connected QB Desktop, Please create an account for this type and sync again to have those listed *"
    const CityName =
      taxDisplayNames &&
      taxDisplayNames.length &&
      taxDisplayNames.filter((tax) => tax.taxTerritory === 'City')
    const StateName =
      taxDisplayNames &&
      taxDisplayNames.length &&
      taxDisplayNames.filter((tax) => tax.taxTerritory === 'State')
    const CountryName =
      taxDisplayNames &&
      taxDisplayNames.length &&
      taxDisplayNames.filter((tax) => tax.taxTerritory === 'County')
    const FederalName =
      taxDisplayNames &&
      taxDisplayNames.length &&
      taxDisplayNames.filter((tax) => tax.taxTerritory === 'Federal')
    const isQuickBookEntityDisable =
      quickBookEntity && (quickBookEntity.version || !quickBookEntity.version)
    //const isQuickBookEntityDisable =  quickBookEntity ? !quickBookEntity.version ? true : false : null; //old

    let qbBothAccountInfo
    if (qbtypes == 'quickbook_online') {
      if (activeTab == 'Config') {
        activeTab = 'Sync Details'
      }
      qbBothAccountInfo = qbOnlineAccountInfo
    } else {
      qbBothAccountInfo = qbDesktopAccounts
    }
    return (
      <div style={{}}>
        {this.state.isRouteActive && this.hasAccessQuickBook.bind(this) ? (
          <Grid container>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Paper className="paper-page">
                <div>
                  {quickBookEntity ? (
                    !quickBookEntity.version ? (
                      <ListItem className="margin error_info_version_null">
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                          <div variant="filled" severity="error">
                            <i className="material-icons">info</i>{' '}
                            <span>
                              We have migrated the integration and hence you have to Reset all
                              information related to QuickBook.
                            </span>
                          </div>
                        </Grid>
                      </ListItem>
                    ) : null
                  ) : null}
                  <ListItem className="margin">
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <FormControl component="fieldset">
                        <FormLabel component="legend">Quickbooks Types</FormLabel>
                        <RadioGroup
                          aria-label="Quickbooks Types"
                          name="qbtypes"
                          value={qbtypes ? qbtypes : 'quickbook_desktop'}
                          onChange={this.handleChange('qbtypes')}
                        >
                          <FormControlLabel
                            value="quickbook_desktop"
                            control={<Radio />}
                            label="QuickBook Desktop"
                            disabled={isQuickBookEntityDisable}
                          />
                          <FormControlLabel
                            value="quickbook_online"
                            control={<Radio />}
                            label="QuickBook Online"
                            disabled={isQuickBookEntityDisable}
                          />
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                  </ListItem>
                  <ListItem className="margin">
                    <Grid item xs={12} sm={12} md={12} lg={12} className="cus_listing">
                      <FormControl component="fieldset">
                        <FormLabel component="legend">Quickbooks Methodology</FormLabel>
                        <RadioGroup
                          aria-label="Quickbooks Methodology"
                          name="quickbookmethology"
                          value={quickbookmethology ? quickbookmethology : 'sync individual'}
                          onChange={this.handleChange('quickbookmethology')}
                        >
                          <FormControlLabel
                            value="sync individual"
                            control={<Radio />}
                            label="Sync individual transactions, individual product details, customers, vendors, and purchase orders. With this, each transaction in BLAZE is its individual entry in Quickbooks. If you have 200 transactions for the day, 200 invoice entries would be made."
                            disabled={isQuickBookEntityDisable}
                          />
                          <FormControlLabel
                            value="sync sales by product category"
                            control={<Radio />}
                            label="Sync based on the aggregation of Sales by Product Category. By doing this, BLAZE would sync one entry for each Product category. If you had 10 product categories, then there would be 10 invoices for those categories."
                            disabled={isQuickBookEntityDisable}
                          />
                          {/*<FormControlLabel value="sync sales by consumer type" control={<Radio/>}*/}
                          {/*label="Sync based on the aggregation of Sales by Consumer. By doing this, BLAZE would sync one entry for each Consumer Type(Adult Use, Medicinal-MMIC, Medicinal-3rd Party). Inventory would be synced based on product category."/>*/}
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid container>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <FormLabel component="legend">Sync Time Strategy</FormLabel>
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        <Select
                          onChange={this.handleChange('syncStrategy')}
                          // value={syncStrategy ? syncStrategy : "from current date"}
                          value="from current date"
                          fullWidth
                          disabled={isQuickBookEntityDisable}
                        >
                          /* For now we are only supporting Sync from Current date*/
                          <MenuItem selected={true} value="from current date">
                            From current date
                          </MenuItem>
                        </Select>
                      </Grid>
                    </Grid>
                  </ListItem>

                  {qbtypes && qbtypes == 'quickbook_online' ? (
                    <ListItem>
                      <Grid container>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                          <FormLabel component="legend">Import Products?</FormLabel>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                          <Checkbox
                            disabled={isQuickBookEntityDisable}
                            checked={syncAllProducts}
                            onChange={this.handleChange('syncAllProducts', true)}
                          />
                        </Grid>
                      </Grid>
                    </ListItem>
                  ) : null}

                  {!this.state.isSaved && this.state.qbCustomAccount !== 'None' ? (
                    <ListItem className="margin">
                      <Grid container>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                          <FormLabel component="legend">
                            Do you want to reset all information related to QuickBook?
                          </FormLabel>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={6} className="btn-margin">
                          <Button
                            className="primary-button margin"
                            onClick={this.disconnect}
                            disabled={
                              quickBookEntity ? (!quickBookEntity.version ? true : false) : null
                            }
                          >
                            Disconnect
                          </Button>
                          <Button
                            className="primary-button margin"
                            onClick={this.openResetModal.bind(this)}
                          >
                            Reset
                          </Button>
                        </Grid>
                      </Grid>

                      <ModalDialog
                        title={'Reset'}
                        ref={(c) => (this.resetModal = c)}
                        onConfirm={this.Reset.bind(this)}
                        confirmText={'Confirm'}
                      >
                        * Are you sure reset all information related to QuickBook?
                      </ModalDialog>
                    </ListItem>
                  ) : null}
                  {this.state.isSaved ? (
                    <ListItem>
                      <Grid item xs={12} sm={12} md={12} lg={12} className="btn-margin">
                        <Button className="primary-button margin" onClick={this.saveSyncStrategies}>
                          Save
                        </Button>
                        {/*{qbtypes == "quickbook_online" ? <Button className="margin" onClick={this.getToken}><img style={{'width':'180px'}} src={C2QB} /></Button> :*/}
                        {/*<Button className="primary-button margin" onClick={this.downloadFile}>Download File</Button>}*/}
                      </Grid>
                    </ListItem>
                  ) : null}
                </div>
              </Paper>
            </Grid>
            {quickBookEntity ? (
              !quickBookEntity.version ? null : !this.state.isSaved &&
                (this.state.qbCustomAccount !== 'None' || accounts) ? (
                <Grid className="loyaltyRewards" item xs={12} sm={12} md={12} lg={12}>
                  {qbtypes === 'quickbook_online' ? (
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <Paper className="paper-page margin-top-small">
                        <Grid container>
                          {quickBookEntity && quickBookEntity.quickBookOnline ? (
                            <Grid container>
                              <ListItem>
                                <Grid container>
                                  <Grid item xs={12} sm={6} md={6} lg={6}>
                                    <FormLabel component="legend">
                                      QuickBooks Online Token Information
                                    </FormLabel>
                                  </Grid>
                                  <Grid item xs={12} sm={6} md={6} lg={6}>
                                    <Button
                                      className="primary-button margin"
                                      style={{ float: 'right' }}
                                      onClick={this.dataSync.bind(this)}
                                    >
                                      Re-Sync
                                    </Button>
                                  </Grid>
                                </Grid>
                              </ListItem>
                              <ListItem>
                                <Grid container>
                                  <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                                    Quickbook Company ID
                                  </Grid>
                                  <Grid item xs={12} sm={6} md={6} lg={6} className="btn-margin">
                                    {this.state.tokenInfo &&
                                    this.state.tokenInfo.quickBook_CompanyId
                                      ? this.state.tokenInfo.quickBook_CompanyId
                                      : 'N/A'}
                                  </Grid>
                                </Grid>
                              </ListItem>
                              <ListItem>
                                <Grid container>
                                  <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                                    Access Token valid upto :&nbsp;
                                    {this.state.tokenInfo &&
                                    this.state.tokenInfo.modified &&
                                    this.state.tokenInfo.expires_in
                                      ? moment(
                                          this.state.tokenInfo.modified +
                                            this.state.tokenInfo.expires_in * 1000,
                                        ).format('hh:mm A') +
                                        ' ' +
                                        moment(
                                          this.state.tokenInfo.modified +
                                            this.state.tokenInfo.expires_in * 1000,
                                        ).format('MM/DD/YYYY')
                                      : 'N/A'}
                                  </Grid>
                                  <Grid item xs={12} sm={6} md={6} lg={6} className="btn-margin">
                                    <Button
                                      className="primary-button margin"
                                      onClick={this.getRefreshToken.bind(this)}
                                    >
                                      Refresh Token
                                    </Button>
                                  </Grid>
                                </Grid>
                              </ListItem>
                              <ListItem>
                                <Grid container>
                                  <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                                    Refresh Token valid upto :&nbsp;
                                    {this.state.tokenInfo &&
                                    this.state.tokenInfo.modified &&
                                    this.state.tokenInfo.x_refresh_token_expires_in
                                      ? moment(
                                          this.state.tokenInfo.modified +
                                            this.state.tokenInfo.x_refresh_token_expires_in * 1000,
                                        ).format('hh:mm A') +
                                        ' ' +
                                        moment(
                                          this.state.tokenInfo.modified +
                                            this.state.tokenInfo.x_refresh_token_expires_in * 1000,
                                        ).format('MM/DD/YYYY')
                                      : 'N/A'}
                                  </Grid>
                                  <Grid item xs={12} sm={6} md={6} lg={6} className="btn-margin">
                                    <Button
                                      className="primary-button margin"
                                      onClick={this.revokeToken.bind(this)}
                                    >
                                      Revoke Token
                                    </Button>
                                  </Grid>
                                </Grid>
                              </ListItem>
                            </Grid>
                          ) : (
                            <Grid container>
                              <ListItem>
                                <Grid container>
                                  <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <FormLabel component="legend">
                                      Click Below to connect with QuickBooks Online
                                    </FormLabel>
                                  </Grid>
                                </Grid>
                              </ListItem>
                              <ListItem>
                                <Grid item xs={12} sm={6} md={6} lg={6} className="btn-margin">
                                  <Button
                                    style={{ padding: '0' }}
                                    onClick={this.launchPopupQuickBookOnline.bind(this)}
                                  >
                                    <img height="40" src={C2QB} />
                                  </Button>
                                </Grid>
                              </ListItem>
                            </Grid>
                          )}
                        </Grid>
                      </Paper>
                    </Grid>
                  ) : (
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <Paper className="paper-page margin-top-small">
                        <Grid container>
                          <ListItem>
                            <Grid container>
                              <Grid item xs={12} sm={4} md={4} lg={4}>
                                <FormLabel component="legend">QWC File Details</FormLabel>
                              </Grid>
                            </Grid>
                          </ListItem>
                          <ListItem>
                            <Grid container>
                              <Grid item xs={12} sm={4} md={4} lg={4}>
                                <FormLabel component="legend">Current Password</FormLabel>
                              </Grid>
                              <Grid item xs={12} sm={6} md={6} lg={6}>
                                {this.state.quickBookEntity && this.state.quickBookEntity.qbPassword
                                  ? this.state.quickBookEntity.qbPassword
                                  : 'No Password Set'}
                              </Grid>
                            </Grid>
                          </ListItem>
                          <ListItem>
                            {this.state.quickBookEntity &&
                            this.state.quickBookEntity.qbPassword !== null ? (
                              <Grid item xs={12} sm={6} md={6} lg={6} className="btn-margin">
                                <Button
                                  className="primary-button margin"
                                  onClick={this.getQwcFile.bind(this)}
                                >
                                  Download QWC File
                                </Button>
                                <Button
                                  className="primary-button margin"
                                  onClick={this.openPasswordModal.bind(this)}
                                >
                                  Reset Password
                                </Button>
                              </Grid>
                            ) : (
                              <Grid item xs={12} sm={6} md={6} lg={6} className="btn-margin">
                                <Button
                                  className="primary-button margin"
                                  onClick={this.openPasswordModal.bind(this)}
                                >
                                  Download QWC File
                                </Button>
                              </Grid>
                            )}
                          </ListItem>
                        </Grid>
                      </Paper>
                    </Grid>
                  )}

                  <Grid className="loyaltyRewards" item xs={12} sm={12} md={12} lg={12}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <Paper className="paper-page margin-top-small">
                        {this.state.qbCustomAccount === 'Custom' ? (
                          <Grid container>
                            <ListItem>
                              <Grid container>
                                <Grid item xs={12} sm={4} md={4} lg={4}>
                                  <FormLabel component="legend">
                                    <h4>Account Details</h4>
                                  </FormLabel>
                                </Grid>
                              </Grid>
                            </ListItem>
                            <ListItem>
                              <Grid container>
                                <Grid item xs={12} sm={4} md={4} lg={4}>
                                  <FormLabel>Account Description</FormLabel>
                                </Grid>
                                <Grid item xs={12} sm={2} md={2} lg={2}>
                                  <FormLabel>Account Type</FormLabel>
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                  <FormLabel>Account Name</FormLabel>
                                </Grid>
                              </Grid>
                            </ListItem>
                            <ListItem>
                              <Grid container>
                                <Grid item xs={12} sm={4} md={4} lg={4}>
                                  Bank Account where all sales are deposited
                                </Grid>
                                <Grid item xs={12} sm={2} md={2} lg={2}>
                                  Bank
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                  <EditableTextField
                                    editMode={true}
                                    value={checking}
                                    disabled={accounts}
                                    onChange={this.handleChange('checking')}
                                    type="text"
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                  />
                                </Grid>
                              </Grid>
                            </ListItem>
                            <ListItem>
                              <Grid container>
                                <Grid className="labelField" item xs={12} sm={4} md={4} lg={4}>
                                  Cost of Goods Sold
                                </Grid>
                                <Grid item xs={12} sm={2} md={2} lg={2}>
                                  CostOfGoodsSold
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                  <EditableTextField
                                    editMode={true}
                                    value={suppliesAndMaterials}
                                    disabled={accounts}
                                    onChange={this.handleChange('suppliesAndMaterials')}
                                    type="text"
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                  />
                                </Grid>
                              </Grid>
                            </ListItem>
                            <ListItem>
                              <Grid container>
                                <Grid item xs={12} sm={4} md={4} lg={4}>
                                  Inventory Account
                                </Grid>
                                <Grid item xs={12} sm={2} md={2} lg={2}>
                                  OtherCurrentAsset
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                  <EditableTextField
                                    editMode={true}
                                    value={inventory}
                                    disabled={accounts}
                                    onChange={this.handleChange('inventory')}
                                    type="text"
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                  />
                                </Grid>
                              </Grid>
                            </ListItem>
                            <ListItem>
                              <Grid container>
                                <Grid item xs={12} sm={4} md={4} lg={4}>
                                  Sales of Product Income On BLAZE transactions
                                </Grid>
                                <Grid item xs={12} sm={2} md={2} lg={2}>
                                  Income
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                  <EditableTextField
                                    editMode={true}
                                    value={sales}
                                    disabled={accounts}
                                    onChange={this.handleChange('sales')}
                                    type="text"
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                  />
                                </Grid>
                              </Grid>
                            </ListItem>
                            <ListItem>
                              <Grid container>
                                <Grid item xs={12} sm={4} md={4} lg={4}>
                                  Payable Accounts
                                </Grid>
                                <Grid item xs={12} sm={2} md={2} lg={2}>
                                  AccountsPayable
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                  <EditableTextField
                                    editMode={true}
                                    value={payableAccount}
                                    disabled={accounts}
                                    onChange={this.handleChange('payableAccount')}
                                    type="text"
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                  />
                                </Grid>
                              </Grid>
                            </ListItem>
                            <ListItem>
                              <Grid container>
                                <Grid item xs={12} sm={4} md={4} lg={4}>
                                  Cannabis Clearance Account
                                </Grid>
                                <Grid item xs={12} sm={2} md={2} lg={2}>
                                  OtherCurrentAsset
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                  <EditableTextField
                                    editMode={true}
                                    value={clearance}
                                    disabled={accounts}
                                    onChange={this.handleChange('clearance')}
                                    type="text"
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                  />
                                </Grid>
                              </Grid>
                            </ListItem>
                            <ListItem>
                              <Grid container>
                                <Grid item xs={12} sm={4} md={4} lg={4}>
                                  Credit Card Clearance Account
                                </Grid>
                                <Grid item xs={12} sm={2} md={2} lg={2}>
                                  OtherCurrentAsset
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                  <EditableTextField
                                    editMode={true}
                                    value={cc_clearance}
                                    disabled={accounts}
                                    onChange={this.handleChange('cc_clearance')}
                                    type="text"
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                  />
                                </Grid>
                              </Grid>
                            </ListItem>
                            <ListItem>
                              <Grid container>
                                <Grid item xs={12} sm={4} md={4} lg={4}>
                                  Receivable Accounts
                                </Grid>
                                <Grid item xs={12} sm={2} md={2} lg={2}>
                                  AccountsReceivable
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                  <EditableTextField
                                    editMode={true}
                                    value={receivable}
                                    disabled={accounts}
                                    onChange={this.handleChange('receivable')}
                                    type="text"
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                  />
                                </Grid>
                              </Grid>
                            </ListItem>
                            {getShop &&
                            getShop.appTarget === 'Retail' &&
                            quickbookmethology === 'sync individual' ? (
                              <React.Fragment>
                                <ListItem>
                                  <Grid container>
                                    <Grid item xs={12} sm={4} md={4} lg={4}>
                                      {CityName && CityName.length && CityName[0].name}
                                    </Grid>
                                    <Grid item xs={12} sm={2} md={2} lg={2}>
                                      OtherCurrentAsset
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={6} lg={6}>
                                      <EditableTextField
                                        editMode={true}
                                        value={cityTaxAcc}
                                        disabled={accounts}
                                        onChange={this.handleChange('cityTaxAcc')}
                                        type="text"
                                        InputLabelProps={{
                                          shrink: true,
                                        }}
                                      />
                                    </Grid>
                                  </Grid>
                                </ListItem>
                                <ListItem>
                                  <Grid container>
                                    <Grid item xs={12} sm={4} md={4} lg={4}>
                                      {StateName && StateName.length && StateName[0].name}
                                    </Grid>
                                    <Grid item xs={12} sm={2} md={2} lg={2}>
                                      OtherCurrentAsset
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={6} lg={6}>
                                      <EditableTextField
                                        editMode={true}
                                        value={stateTaxAcc}
                                        disabled={accounts}
                                        onChange={this.handleChange('stateTaxAcc')}
                                        type="text"
                                        InputLabelProps={{
                                          shrink: true,
                                        }}
                                      />
                                    </Grid>
                                  </Grid>
                                </ListItem>
                                <ListItem>
                                  <Grid container>
                                    <Grid item xs={12} sm={4} md={4} lg={4}>
                                      {CountryName && CountryName.length && CountryName[0].name}
                                    </Grid>
                                    <Grid item xs={12} sm={2} md={2} lg={2}>
                                      OtherCurrentAsset
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={6} lg={6}>
                                      <EditableTextField
                                        editMode={true}
                                        value={countyTaxAcc}
                                        disabled={accounts}
                                        onChange={this.handleChange('countyTaxAcc')}
                                        type="text"
                                        InputLabelProps={{
                                          shrink: true,
                                        }}
                                      />
                                    </Grid>
                                  </Grid>
                                </ListItem>
                                <ListItem>
                                  <Grid container>
                                    <Grid item xs={12} sm={4} md={4} lg={4}>
                                      {FederalName && FederalName.length && FederalName[0].name}
                                    </Grid>
                                    <Grid item xs={12} sm={2} md={2} lg={2}>
                                      OtherCurrentAsset
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={6} lg={6}>
                                      <EditableTextField
                                        editMode={true}
                                        value={federalTaxAcc}
                                        disabled={accounts}
                                        onChange={this.handleChange('federalTaxAcc')}
                                        type="text"
                                        InputLabelProps={{
                                          shrink: true,
                                        }}
                                      />
                                    </Grid>
                                  </Grid>
                                </ListItem>
                              </React.Fragment>
                            ) : null}
                            {getShop && getShop.appTarget === 'Distribution' ? (
                              <ListItem>
                                <Grid container>
                                  <Grid item xs={12} sm={4} md={4} lg={4}>
                                    Cultivation Tax
                                  </Grid>
                                  <Grid item xs={12} sm={2} md={2} lg={2}>
                                    OtherCurrentAsset
                                  </Grid>
                                  <Grid item xs={12} sm={6} md={6} lg={6}>
                                    <EditableTextField
                                      editMode={true}
                                      value={cultivationTaxAcc}
                                      disabled={accounts}
                                      onChange={this.handleChange('cultivationTaxAcc')}
                                      type="text"
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                    />
                                  </Grid>
                                </Grid>
                              </ListItem>
                            ) : null}
                            {accounts &&
                            this.state.qbCustomAccount &&
                            qbDesktopAccounts &&
                            qbDesktopAccounts.length > 0 ? (
                              <ListItem>
                                <Grid item xs={12} sm={12} md={12} lg={12} className="btn-margin">
                                  {qbtypes === 'quickbook_online' ? (
                                    <Button className="margin" onClick={this.getToken}>
                                      <img style={{ width: '180px' }} src={C2QB} />
                                    </Button>
                                  ) : (
                                    <Button
                                      className="primary-button margin"
                                      onClick={this.openPasswordModal.bind(this)}
                                    >
                                      Download File
                                    </Button>
                                  )}
                                </Grid>
                              </ListItem>
                            ) : (
                              <Button
                                className="primary-button margin margin-left-small"
                                onClick={this.openModal}
                              >
                                Save Accounts
                              </Button>
                            )}
                          </Grid>
                        ) : null}
                        {this.state.qbCustomAccount === 'QbSync' ? (
                          qbBothAccountInfo && qbBothAccountInfo.length > 0 ? (
                            <Grid container>
                              <ListItem>
                                <Grid container>
                                  <Grid item xs={12} sm={4} md={4} lg={4}>
                                    <FormLabel component="legend">Account Details</FormLabel>
                                  </Grid>
                                </Grid>
                              </ListItem>
                              <ListItem>
                                <Grid container>
                                  <Grid item xs={12} sm={4} md={4} lg={4}>
                                    <FormLabel>Account Description</FormLabel>
                                  </Grid>
                                  <Grid item xs={12} sm={2} md={2} lg={2}>
                                    <FormLabel>Account Type</FormLabel>
                                  </Grid>
                                  <Grid item xs={12} sm={6} md={6} lg={6}>
                                    <FormLabel>Account Name</FormLabel>
                                  </Grid>
                                </Grid>
                              </ListItem>
                              <ListItem>
                                <Grid container>
                                  <Grid item xs={12} sm={4} md={4} lg={4}>
                                    Bank Account where all sales are deposited
                                  </Grid>
                                  <Grid item xs={12} sm={2} md={2} lg={2}>
                                    Bank
                                  </Grid>
                                  <Grid item xs={12} sm={6} md={6} lg={6}>
                                    {qbBothAccountInfo.filter(
                                      (accountsAssetDetails) =>
                                        accountsAssetDetails.accountType == 'BANK' ||
                                        accountsAssetDetails.accountType == 'Bank',
                                    ).length > 0 ? (
                                      <Select
                                        displayEmpty={true}
                                        value={checking ? checking : ''}
                                        fullWidth
                                        onChange={this.handleChange('checking')}
                                      >
                                        <MenuItem value="">Select</MenuItem>
                                        {qbBothAccountInfo
                                          .filter(
                                            (accountsAssetDetails) =>
                                              accountsAssetDetails.accountType == 'BANK' ||
                                              accountsAssetDetails.accountType == 'Bank',
                                          )
                                          .map((accountsAssetDetails, i) => {
                                            return (
                                              <MenuItem
                                                key={i}
                                                value={accountsAssetDetails.accountId}
                                              >
                                                {accountsAssetDetails.accountName}
                                              </MenuItem>
                                            )
                                          })}
                                      </Select>
                                    ) : (
                                      <div item xs={12} sm={6} md={6} lg={6}>
                                        {noAcconut}
                                      </div>
                                    )}
                                  </Grid>
                                </Grid>
                              </ListItem>
                              <ListItem>
                                <Grid container>
                                  <Grid item xs={12} sm={4} md={4} lg={4}>
                                    Cost of Goods Sold
                                  </Grid>
                                  <Grid item xs={12} sm={2} md={2} lg={2}>
                                    CostOfGoodsSold
                                  </Grid>
                                  <Grid item xs={12} sm={6} md={6} lg={6}>
                                    {qbBothAccountInfo.filter(
                                      (accountsAssetDetails) =>
                                        accountsAssetDetails.accountType == 'COST_OF_GOODS_SOLD' ||
                                        accountsAssetDetails.accountType == 'CostOfGoodsSold',
                                    ).length > 0 ? (
                                      <Select
                                        displayEmpty={true}
                                        value={suppliesAndMaterials}
                                        fullWidth
                                        onChange={this.handleChange('suppliesAndMaterials')}
                                      >
                                        <MenuItem value="">Select</MenuItem>
                                        {qbBothAccountInfo
                                          .filter(
                                            (accountsAssetDetails) =>
                                              accountsAssetDetails.accountType ==
                                                'COST_OF_GOODS_SOLD' ||
                                              accountsAssetDetails.accountType == 'CostOfGoodsSold',
                                          )
                                          .map((accountsAssetDetails, i) => {
                                            return (
                                              <MenuItem
                                                key={i}
                                                value={accountsAssetDetails.accountId}
                                              >
                                                {accountsAssetDetails.accountName}
                                              </MenuItem>
                                            )
                                          })}
                                      </Select>
                                    ) : (
                                      <Grid item xs={12} sm={6} md={6} lg={6}>
                                        {' '}
                                        {noAcconut}
                                      </Grid>
                                    )}
                                  </Grid>
                                </Grid>
                              </ListItem>
                              <ListItem>
                                <Grid container>
                                  <Grid item xs={12} sm={4} md={4} lg={4}>
                                    Inventory Account
                                  </Grid>
                                  <Grid item xs={12} sm={2} md={2} lg={2}>
                                    OtherCurrentAsset
                                  </Grid>
                                  {qbBothAccountInfo.filter(
                                    (accountsAssetDetails) =>
                                      accountsAssetDetails.accountType == 'OTHER_CURRENT_ASSET' ||
                                      accountsAssetDetails.accountType == 'OtherCurrentAsset',
                                  ).length > 0 ? (
                                    <Grid item xs={12} sm={6} md={6} lg={6}>
                                      <Select
                                        displayEmpty={true}
                                        value={inventory ? inventory : ''}
                                        fullWidth
                                        onChange={this.handleChange('inventory')}
                                      >
                                        <MenuItem value="">Select</MenuItem>
                                        {qbBothAccountInfo
                                          .filter(
                                            (accountsAssetDetails) =>
                                              accountsAssetDetails.accountType ==
                                                'OTHER_CURRENT_ASSET' ||
                                              accountsAssetDetails.accountType ==
                                                'OtherCurrentAsset',
                                          )
                                          .map((accountsAssetDetails, key) => {
                                            return (
                                              <MenuItem
                                                key={key}
                                                value={accountsAssetDetails.accountId}
                                              >
                                                {accountsAssetDetails.accountName}
                                              </MenuItem>
                                            )
                                          })}
                                      </Select>
                                    </Grid>
                                  ) : (
                                    <Grid item xs={12} sm={6} md={6} lg={6}>
                                      {' '}
                                      {noAcconut}
                                    </Grid>
                                  )}
                                </Grid>
                              </ListItem>
                              <ListItem>
                                <Grid container>
                                  <Grid item xs={12} sm={4} md={4} lg={4}>
                                    Sales of Product Income On BLAZE transactions
                                  </Grid>
                                  <Grid item xs={12} sm={2} md={2} lg={2}>
                                    Income
                                  </Grid>
                                  <Grid item xs={12} sm={6} md={6} lg={6}>
                                    {qbBothAccountInfo.filter(
                                      (accountsAssetDetails) =>
                                        accountsAssetDetails.accountType == 'INCOME' ||
                                        accountsAssetDetails.accountType == 'Income',
                                    ).length > 0 ? (
                                      <Select
                                        displayEmpty={true}
                                        value={sales ? sales : ''}
                                        fullWidth
                                        onChange={this.handleChange('sales')}
                                      >
                                        <MenuItem value="">Select</MenuItem>
                                        {qbBothAccountInfo
                                          .filter(
                                            (accountsAssetDetails) =>
                                              accountsAssetDetails.accountType == 'INCOME' ||
                                              accountsAssetDetails.accountType == 'Income',
                                          )
                                          .map((accountsAssetDetails, key) => {
                                            return (
                                              <MenuItem
                                                key={key}
                                                value={accountsAssetDetails.accountId}
                                              >
                                                {accountsAssetDetails.accountName}
                                              </MenuItem>
                                            )
                                          })}
                                      </Select>
                                    ) : (
                                      <Grid item xs={12} sm={6} md={6} lg={6}>
                                        {' '}
                                        {noAcconut}
                                      </Grid>
                                    )}
                                  </Grid>
                                </Grid>
                              </ListItem>
                              <ListItem>
                                <Grid container>
                                  <Grid item xs={12} sm={4} md={4} lg={4}>
                                    Payable Accounts
                                  </Grid>
                                  <Grid item xs={12} sm={2} md={2} lg={2}>
                                    AccountsPayable
                                  </Grid>
                                  <Grid item xs={12} sm={6} md={6} lg={6}>
                                    {qbBothAccountInfo.filter(
                                      (accountsAssetDetails) =>
                                        accountsAssetDetails.accountType == 'ACCOUNTS_PAYABLE' ||
                                        accountsAssetDetails.accountType == 'AccountsPayable',
                                    ).length > 0 ? (
                                      <Select
                                        displayEmpty={true}
                                        value={payableAccount ? payableAccount : ''}
                                        fullWidth
                                        onChange={this.handleChange('payableAccount')}
                                      >
                                        <MenuItem value="">Select</MenuItem>
                                        {qbBothAccountInfo
                                          .filter(
                                            (accountsAssetDetails) =>
                                              accountsAssetDetails.accountType ==
                                                'ACCOUNTS_PAYABLE' ||
                                              accountsAssetDetails.accountType == 'AccountsPayable',
                                          )
                                          .map((accountsAssetDetails, key) => {
                                            return (
                                              <MenuItem
                                                key={key}
                                                value={accountsAssetDetails.accountId}
                                              >
                                                {accountsAssetDetails.accountName}
                                              </MenuItem>
                                            )
                                          })}
                                      </Select>
                                    ) : (
                                      <div item xs={12} sm={6} md={6} lg={6}>
                                        {' '}
                                        {noAcconut}
                                      </div>
                                    )}
                                  </Grid>
                                </Grid>
                              </ListItem>
                              <ListItem>
                                <Grid container>
                                  <Grid item xs={12} sm={4} md={4} lg={4}>
                                    Cannabis Clearance Account
                                  </Grid>
                                  <Grid item xs={12} sm={2} md={2} lg={2}>
                                    OtherCurrentAsset
                                  </Grid>
                                  <Grid item xs={12} sm={6} md={6} lg={6}>
                                    {qbBothAccountInfo.filter(
                                      (accountsAssetDetails) =>
                                        accountsAssetDetails.accountType == 'OTHER_CURRENT_ASSET' ||
                                        accountsAssetDetails.accountType == 'OtherCurrentAsset',
                                    ).length > 0 ? (
                                      <Select
                                        displayEmpty={true}
                                        value={clearance ? clearance : ''}
                                        fullWidth
                                        onChange={this.handleChange('clearance')}
                                      >
                                        <MenuItem value="">Select</MenuItem>
                                        {qbBothAccountInfo
                                          .filter(
                                            (accountsAssetDetails) =>
                                              accountsAssetDetails.accountType ==
                                                'OTHER_CURRENT_ASSET' ||
                                              accountsAssetDetails.accountType ==
                                                'OtherCurrentAsset',
                                          )
                                          .map((accountsAssetDetails, key) => {
                                            return (
                                              <MenuItem
                                                key={key}
                                                value={accountsAssetDetails.accountId}
                                              >
                                                {accountsAssetDetails.accountName}
                                              </MenuItem>
                                            )
                                          })}
                                      </Select>
                                    ) : (
                                      <div item xs={12} sm={6} md={6} lg={6}>
                                        {' '}
                                        {noAcconut}
                                      </div>
                                    )}
                                  </Grid>
                                </Grid>
                              </ListItem>
                              <ListItem>
                                <Grid container>
                                  <Grid item xs={12} sm={4} md={4} lg={4}>
                                    Credit Card Clearance Account
                                  </Grid>
                                  <Grid item xs={12} sm={2} md={2} lg={2}>
                                    OtherCurrentAsset
                                  </Grid>
                                  <Grid item xs={12} sm={6} md={6} lg={6}>
                                    {qbBothAccountInfo.filter(
                                      (accountsAssetDetails) =>
                                        accountsAssetDetails.accountType == 'OTHER_CURRENT_ASSET' ||
                                        accountsAssetDetails.accountType == 'OtherCurrentAsset',
                                    ).length > 0 ? (
                                      <Select
                                        displayEmpty={true}
                                        value={cc_clearance ? cc_clearance : ''}
                                        fullWidth
                                        onChange={this.handleChange('cc_clearance')}
                                      >
                                        <MenuItem value="">Select</MenuItem>
                                        {qbBothAccountInfo
                                          .filter(
                                            (accountsAssetDetails) =>
                                              accountsAssetDetails.accountType ==
                                                'OTHER_CURRENT_ASSET' ||
                                              accountsAssetDetails.accountType ==
                                                'OtherCurrentAsset',
                                          )
                                          .map((accountsAssetDetails, key) => {
                                            return (
                                              <MenuItem
                                                key={key}
                                                value={accountsAssetDetails.accountId}
                                              >
                                                {accountsAssetDetails.accountName}
                                              </MenuItem>
                                            )
                                          })}
                                      </Select>
                                    ) : (
                                      <div item xs={12} sm={6} md={6} lg={6}>
                                        {' '}
                                        {noAcconut}
                                      </div>
                                    )}
                                  </Grid>
                                </Grid>
                              </ListItem>
                              <ListItem>
                                <Grid container>
                                  <Grid item xs={12} sm={4} md={4} lg={4}>
                                    Receivable Account
                                  </Grid>
                                  <Grid item xs={12} sm={2} md={2} lg={2}>
                                    AccountsReceivable
                                  </Grid>
                                  <Grid item xs={12} sm={6} md={6} lg={6}>
                                    {qbBothAccountInfo.filter(
                                      (accountsAssetDetails) =>
                                        accountsAssetDetails.accountType == 'ACCOUNTS_RECEIVABLE' ||
                                        accountsAssetDetails.accountType == 'AccountsReceivable',
                                    ).length > 0 ? (
                                      <Select
                                        displayEmpty={true}
                                        value={receivable ? receivable : ''}
                                        fullWidth
                                        onChange={this.handleChange('receivable')}
                                      >
                                        <MenuItem value="">Select</MenuItem>
                                        {qbBothAccountInfo
                                          .filter(
                                            (accountsAssetDetails) =>
                                              accountsAssetDetails.accountType ==
                                                'ACCOUNTS_RECEIVABLE' ||
                                              accountsAssetDetails.accountType ==
                                                'AccountsReceivable',
                                          )
                                          .map((accountsAssetDetails, key) => {
                                            return (
                                              <MenuItem
                                                key={key}
                                                value={accountsAssetDetails.accountId}
                                              >
                                                {accountsAssetDetails.accountName}
                                              </MenuItem>
                                            )
                                          })}
                                      </Select>
                                    ) : (
                                      <div item xs={12} sm={6} md={6} lg={6}>
                                        {' '}
                                        {noAcconut}
                                      </div>
                                    )}
                                  </Grid>
                                </Grid>
                              </ListItem>
                              <ListItem>
                                <Grid container>
                                  <Grid item xs={12} sm={4} md={4} lg={4}>
                                    Fees (Delivery/CashlessATM)
                                  </Grid>
                                  <Grid item xs={12} sm={2} md={2} lg={2}>
                                    OtherCurrentAsset
                                  </Grid>
                                  <Grid item xs={12} sm={6} md={6} lg={6}>
                                    {qbBothAccountInfo.filter(
                                      (accountsAssetDetails) =>
                                        accountsAssetDetails.accountType == 'OTHER_CURRENT_ASSET' ||
                                        accountsAssetDetails.accountType == 'OtherCurrentAsset',
                                    ).length > 0 ? (
                                      <Select
                                        displayEmpty={true}
                                        value={feesAcc}
                                        fullWidth
                                        onChange={this.handleChange('feesAcc')}
                                      >
                                        <MenuItem value="">Select</MenuItem>
                                        {qbBothAccountInfo
                                          .filter(
                                            (accountsAssetDetails) =>
                                              accountsAssetDetails.accountType ==
                                                'OTHER_CURRENT_ASSET' ||
                                              accountsAssetDetails.accountType ==
                                                'OtherCurrentAsset',
                                          )
                                          .map((accountsAssetDetails, i) => {
                                            return (
                                              <MenuItem
                                                key={i}
                                                value={accountsAssetDetails.accountId}
                                              >
                                                {accountsAssetDetails.accountName}
                                              </MenuItem>
                                            )
                                          })}
                                      </Select>
                                    ) : (
                                      <Grid item xs={12} sm={6} md={6} lg={6}>
                                        {' '}
                                        {noAcconut}
                                      </Grid>
                                    )}
                                  </Grid>
                                </Grid>
                              </ListItem>
                              {getShop && getShop.appTarget === 'Distribution' ? (
                                <ListItem>
                                  <Grid container>
                                    <Grid item xs={12} sm={4} md={4} lg={4}>
                                      Cultivation Tax
                                    </Grid>
                                    <Grid item xs={12} sm={2} md={2} lg={2}>
                                      OtherCurrentAsset
                                    </Grid>
                                    {qbBothAccountInfo.filter(
                                      (accountsAssetDetails) =>
                                        accountsAssetDetails.accountType == 'OTHER_CURRENT_ASSET' ||
                                        accountsAssetDetails.accountType == 'OtherCurrentAsset',
                                    ).length > 0 ? (
                                      <Grid item xs={12} sm={6} md={6} lg={6}>
                                        <Select
                                          displayEmpty={true}
                                          value={cultivationTaxAcc ? cultivationTaxAcc : ''}
                                          fullWidth
                                          onChange={this.handleChange('cultivationTaxAcc')}
                                        >
                                          <MenuItem value="">Select</MenuItem>
                                          {qbBothAccountInfo
                                            .filter(
                                              (accountsAssetDetails) =>
                                                accountsAssetDetails.accountType ==
                                                  'OTHER_CURRENT_ASSET' ||
                                                accountsAssetDetails.accountType ==
                                                  'OtherCurrentAsset',
                                            )
                                            .map((accountsAssetDetails, key) => {
                                              return (
                                                <MenuItem
                                                  key={key}
                                                  value={accountsAssetDetails.accountId}
                                                >
                                                  {accountsAssetDetails.accountName}
                                                </MenuItem>
                                              )
                                            })}
                                        </Select>
                                      </Grid>
                                    ) : (
                                      <Grid item xs={12} sm={6} md={6} lg={6}>
                                        {' '}
                                        {noAcconut}
                                      </Grid>
                                    )}
                                  </Grid>
                                </ListItem>
                              ) : null}
                              {getShop &&
                              getShop.appTarget ===
                                'Retail' /* && quickbookmethology === "sync individual"*/ ? (
                                <React.Fragment>
                                  <ListItem>
                                    <Grid container>
                                      <Grid item xs={12} sm={4} md={4} lg={4}>
                                        {CityName && CityName.length && CityName[0].name}
                                      </Grid>
                                      <Grid item xs={12} sm={2} md={2} lg={2}>
                                        OtherCurrentAsset
                                      </Grid>
                                      {qbBothAccountInfo.filter(
                                        (accountsAssetDetails) =>
                                          accountsAssetDetails.accountType ==
                                            'OTHER_CURRENT_ASSET' ||
                                          accountsAssetDetails.accountType == 'OtherCurrentAsset',
                                      ).length > 0 ? (
                                        <Grid item xs={12} sm={6} md={6} lg={6}>
                                          <Select
                                            displayEmpty={true}
                                            value={cityTaxAcc ? cityTaxAcc : ''}
                                            fullWidth
                                            onChange={this.handleChange('cityTaxAcc')}
                                          >
                                            <MenuItem value="">Select</MenuItem>
                                            {qbBothAccountInfo
                                              .filter(
                                                (accountsAssetDetails) =>
                                                  accountsAssetDetails.accountType ==
                                                    'OTHER_CURRENT_ASSET' ||
                                                  accountsAssetDetails.accountType ==
                                                    'OtherCurrentAsset',
                                              )
                                              .map((accountsAssetDetails, key) => {
                                                return (
                                                  <MenuItem
                                                    key={key}
                                                    value={accountsAssetDetails.accountId}
                                                  >
                                                    {accountsAssetDetails.accountName}
                                                  </MenuItem>
                                                )
                                              })}
                                          </Select>
                                        </Grid>
                                      ) : (
                                        <Grid item xs={12} sm={6} md={6} lg={6}>
                                          {' '}
                                          {noAcconut}
                                        </Grid>
                                      )}
                                    </Grid>
                                  </ListItem>
                                  <ListItem>
                                    <Grid container>
                                      <Grid item xs={12} sm={4} md={4} lg={4}>
                                        {StateName && StateName.length && StateName[0].name}
                                      </Grid>
                                      <Grid item xs={12} sm={2} md={2} lg={2}>
                                        OtherCurrentAsset
                                      </Grid>
                                      {qbBothAccountInfo.filter(
                                        (accountsAssetDetails) =>
                                          accountsAssetDetails.accountType ==
                                            'OTHER_CURRENT_ASSET' ||
                                          accountsAssetDetails.accountType == 'OtherCurrentAsset',
                                      ).length > 0 ? (
                                        <Grid item xs={12} sm={6} md={6} lg={6}>
                                          <Select
                                            displayEmpty={true}
                                            value={stateTaxAcc ? stateTaxAcc : ''}
                                            fullWidth
                                            onChange={this.handleChange('stateTaxAcc')}
                                          >
                                            <MenuItem value="">Select</MenuItem>
                                            {qbBothAccountInfo
                                              .filter(
                                                (accountsAssetDetails) =>
                                                  accountsAssetDetails.accountType ==
                                                    'OTHER_CURRENT_ASSET' ||
                                                  accountsAssetDetails.accountType ==
                                                    'OtherCurrentAsset',
                                              )
                                              .map((accountsAssetDetails, key) => {
                                                return (
                                                  <MenuItem
                                                    key={key}
                                                    value={accountsAssetDetails.accountId}
                                                  >
                                                    {accountsAssetDetails.accountName}
                                                  </MenuItem>
                                                )
                                              })}
                                          </Select>
                                        </Grid>
                                      ) : (
                                        <Grid item xs={12} sm={6} md={6} lg={6}>
                                          {' '}
                                          {noAcconut}
                                        </Grid>
                                      )}
                                    </Grid>
                                  </ListItem>
                                  <ListItem>
                                    <Grid container>
                                      <Grid item xs={12} sm={4} md={4} lg={4}>
                                        {CountryName && CountryName.length && CountryName[0].name}
                                      </Grid>
                                      <Grid item xs={12} sm={2} md={2} lg={2}>
                                        OtherCurrentAsset
                                      </Grid>
                                      {qbBothAccountInfo.filter(
                                        (accountsAssetDetails) =>
                                          accountsAssetDetails.accountType ==
                                            'OTHER_CURRENT_ASSET' ||
                                          accountsAssetDetails.accountType == 'OtherCurrentAsset',
                                      ).length > 0 ? (
                                        <Grid item xs={12} sm={6} md={6} lg={6}>
                                          <Select
                                            displayEmpty={true}
                                            value={countyTaxAcc ? countyTaxAcc : ''}
                                            fullWidth
                                            onChange={this.handleChange('countyTaxAcc')}
                                          >
                                            <MenuItem value="">Select</MenuItem>
                                            {qbBothAccountInfo
                                              .filter(
                                                (accountsAssetDetails) =>
                                                  accountsAssetDetails.accountType ==
                                                    'OTHER_CURRENT_ASSET' ||
                                                  accountsAssetDetails.accountType ==
                                                    'OtherCurrentAsset',
                                              )
                                              .map((accountsAssetDetails, key) => {
                                                return (
                                                  <MenuItem
                                                    key={key}
                                                    value={accountsAssetDetails.accountId}
                                                  >
                                                    {accountsAssetDetails.accountName}
                                                  </MenuItem>
                                                )
                                              })}
                                          </Select>
                                        </Grid>
                                      ) : (
                                        <Grid item xs={12} sm={6} md={6} lg={6}>
                                          {' '}
                                          {noAcconut}
                                        </Grid>
                                      )}
                                    </Grid>
                                  </ListItem>
                                  <ListItem>
                                    <Grid container>
                                      <Grid item xs={12} sm={4} md={4} lg={4}>
                                        {FederalName && FederalName.length && FederalName[0].name}
                                      </Grid>
                                      <Grid item xs={12} sm={2} md={2} lg={2}>
                                        OtherCurrentAsset
                                      </Grid>
                                      {qbBothAccountInfo.filter(
                                        (accountsAssetDetails) =>
                                          accountsAssetDetails.accountType ==
                                            'OTHER_CURRENT_ASSET' ||
                                          accountsAssetDetails.accountType == 'OtherCurrentAsset',
                                      ).length > 0 ? (
                                        <Grid item xs={12} sm={6} md={6} lg={6}>
                                          <Select
                                            displayEmpty={true}
                                            value={federalTaxAcc ? federalTaxAcc : ''}
                                            fullWidth
                                            onChange={this.handleChange('federalTaxAcc')}
                                          >
                                            <MenuItem value="">Select</MenuItem>
                                            {qbBothAccountInfo
                                              .filter(
                                                (accountsAssetDetails) =>
                                                  accountsAssetDetails.accountType ==
                                                    'OTHER_CURRENT_ASSET' ||
                                                  accountsAssetDetails.accountType ==
                                                    'OtherCurrentAsset',
                                              )
                                              .map((accountsAssetDetails, key) => {
                                                return (
                                                  <MenuItem
                                                    key={key}
                                                    value={accountsAssetDetails.accountId}
                                                  >
                                                    {accountsAssetDetails.accountName}
                                                  </MenuItem>
                                                )
                                              })}
                                          </Select>
                                        </Grid>
                                      ) : (
                                        <Grid item xs={12} sm={6} md={6} lg={6}>
                                          {' '}
                                          {noAcconut}
                                        </Grid>
                                      )}
                                    </Grid>
                                  </ListItem>
                                </React.Fragment>
                              ) : null}
                              <ListItem>
                                <Grid item xs={12} sm={12} md={12} lg={12} className="btn-margin">
                                  <Button
                                    className="primary-button margin"
                                    onClick={this.saveCustomEntities}
                                  >
                                    Save Accounts
                                  </Button>
                                </Grid>
                              </ListItem>
                            </Grid>
                          ) : (
                            <ListItem>
                              <Grid container>
                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                  Accounts have not been synchronized yet.
                                </Grid>
                              </Grid>
                            </ListItem>
                          )
                        ) : null}
                        <ModalDialog
                          title={'Password'}
                          ref={(c) => (this.passwordModal = c)}
                          onConfirm={this.downloadFile.bind(this)}
                          confirmText={'Confirm'}
                        >
                          * This password will be used to authenticate the QB Web Connector, Please
                          configure QB Web Connector with the same password
                          <br />
                          <br />
                          <EditableTextField
                            placeholder="Password"
                            editMode={true}
                            value={qwc_password}
                            onChange={this.handleChange('qwc_password')}
                            type="password"
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </ModalDialog>
                      </Paper>
                    </Grid>

                    {/*:
                                                       <Grid >
                                                            <Paper>
                                                               {this.renderAccountTab(activeAccountTab)}
                                                           </Paper>
                                                       </Grid>
                                                    }
                                             </div>*/}
                    <Paper>
                      <Tabs
                        value={activeTab}
                        onChange={this.handleTabChange}
                        indicatorColor="primary"
                        textColor="primary"
                        centered={true}
                      >
                        {this.qbTabs(qbtypes)}
                      </Tabs>
                    </Paper>
                    {this.renderTab(activeTab)}
                  </Grid>
                </Grid>
              ) : null
            ) : null}
            <ModalDialog
              title={''}
              ref={(c) => (this.confirmModal = c)}
              onConfirm={this.saveCustomEntities}
              confirmText={'Confirm'}
            >
              {this.state.qbCustomAccount === 'QbSync' ? (
                <p>Are you sure you want to add accounts?</p>
              ) : (
                <p>
                  Are you sure you want to add accounts. You won't be able update this later on?
                </p>
              )}
            </ModalDialog>
          </Grid>
        ) : (
          <Grid container>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Paper className="paper-page">
                <ListItem>
                  <FormControl component="fieldset">
                    <FormLabel component="legend">
                      QuickBook is not available for current shop, Please contact support
                      (support@blaze.me) to activate or more details.
                    </FormLabel>
                  </FormControl>
                </ListItem>
              </Paper>
            </Grid>
          </Grid>
        )}
      </div>
    )
  }
}

const QuickBookWithTitle = ContainerWithTitleWrapper(QuickBook, 'Quick Book')
export default connect((state) => {
  return {
    dispatch: state.dispatch,
    shopReducer: state.shopReducer,
  }
})(QuickBookWithTitle)



// WEBPACK FOOTER //
// ./src/containers/Settings/Integration/QuickBook.js